import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import apiFactory from '../factories/api';
import CCButton from '../components/CCButton';
import '../assets/sass/pages/login.sass';
import '../assets/sass/components/errors.sass';
import { useStateValue } from '../contexts/Auth';
import CCIcon from '../components/CCIcon';
import CCCheckbox from '../components/CCCheckbox';

const authAPI = apiFactory.get('auth');

const Login = () => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);

  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState('');
  const [isExternalLogin, setIsExternalLogin] = useState(false);

  // eslint-disable-next-line no-empty-pattern
  const [{}, dispatch] = useStateValue();
  const history = useHistory();

  document.getElementById('collicare-chat').style.display = 'none';

  document.body.removeAttribute('style');

  const domesticSingleSignOn = () => {
    const params = {
      username: email || '',
      password: password || '',
    };
    const form = document.createElement('form');
    form.method = 'post';
    form.action = 'https://order.collicare.no/ccno/opter/Account/ExternalLogin';
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const field = document.createElement('input');
        field.type = 'hidden';
        field.name = key;
        field.value = params[key];
        form.appendChild(field);
      }
    }
    document.body.appendChild(form);
    // console.log(form);
    form.submit();
  };

  const authenticateUser = async (e) => {
    e.preventDefault();
    if (sending) return;
    if (isExternalLogin) {
      domesticSingleSignOn();
    }
    try {
      setSending(true);
      const { data } = await authAPI.login({
        email,
        password,
      });
      setSending(false);

      if (!data) return;

      dispatch({
        type: 'CHANGE_DETAILS',
        payload: data,
      });
    } catch (error) {
      setSending(false);
      console.log(error);
      setErrors(error && error.data && error.data.message);
    }
  };

  const createAccount = () => {
    history.push('/sign-up');
  };

  return (
    (window.navigator.userAgent.match(/MSIE|Trident/) !== null)
    ? (<div
      className="login-container flex flex-fd--column"
      style={{
        paddingBottom: '70px',
      }}>
      <div>
        <CCIcon
          color="black"
          size={120}
        >info
        </CCIcon>
      </div>
      <h1
        style={{
          fontSize: '70px',
          fontWeight: '600',
          marginBottom: '35px',
        }}>Browser not supported</h1>
      <p
        style={{
          fontSize: '24px',
          lineHeight: '1.8'
        }}>This site is not optimized for Internet Explorer and can experience problems.</p>
      <p
        style={{
          fontSize: '24px',
          lineHeight: '1.8'
        }}>We recommend to use Google Chrome.</p>
    </div>)
    : (<div className="login-container">
      <form onSubmit={authenticateUser}>
        <img src={`${process.env.PUBLIC_URL}/images/collicare.svg`} alt="collicare-logo" className="collicare-logo" />
        <img src={`${process.env.PUBLIC_URL}/images/login-header.svg`} alt="login-form-header" className="login-header" />
        <CCCheckbox
          style={{
            marginBottom: '10px',
          }}
          onChange={setIsExternalLogin}
          checked={isExternalLogin}
        >
          Login to Domestic
        </CCCheckbox>
        <div className="input-group">
          <CCIcon
            color="black"
            size={24}
            style={{
              top: '6px',
            }}
          >user
          </CCIcon>
          <input
            name="email"
            id="email"
            type="email"
            value={email}
            placeholder="Email"
            onChange={event => setEmail(event.target.value)}
          />
        </div>
        <div className="input-group">
          <CCIcon color="black">lock</CCIcon>
          <input
            name="password"
            id="password"
            type="password"
            value={password}
            placeholder="Password"
            onChange={event => setPassword(event.target.value)}
          />
          {
            errors
              ? (
                <p className="errors-label errors-label--margin-bottom">{errors}</p>
              )
              : ''
          }
        </div>
        <div
          className="actions"
          style={{ justifyContent: 'flex-end' }}
        >
          {/* <Link
            to="/sign-up"
            className="sign-up-link"
          >
            Sign up
          </Link> */}
          <CCButton
            type="primary"
            nativeType="submit"
            label="Sign In"
            icon="arrow-right"
            iconPosition="right"
            className={`btn-login-form ${sending ? 'btn-loading' : ''}`}
            onClick={authenticateUser}
          />
        </div>
        <div
          className="actions"
          style={{ marginTop: '10px' }}
        >
          <Link
            to="/forgot-password"
            className="forgot-password-link"
          >
            Forgot Password
          </Link>
          <CCButton
            type="primary"
            nativeType="submit"
            label="Request for new account"
            icon="arrow-right"
            iconPosition="right"
            className="btn-login-form"
            style={{ fontSize: '12px' }}
            onClick={createAccount}
          />
        </div>
      </form>
    </div>)
  );
};

export default Login;
